
<template>
  <!-- 血压计列表 4G血压计 -->
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        @submit.native.prevent
      >
          <el-button
            type="warning"
            icon="el-icon-back"
            plain
            @click="back"
            >返回</el-button
          >
        <el-form-item label="状态:">
          <el-select
              v-model="formInline.ano"
              placeholder="请选择"
              clearable>
              <el-option key="0" label="正常" value="0"></el-option>
              <el-option key="1" label="不正常" value="1"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            plain
            @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <el-table
          :data="list"
          style="width: 100%"
          :row-style="tableRowStyle"
          :header-cell-style="tableHeaderColor"
        >
          <el-table-column
            label="设备编号"
            align="center"
            prop="deviceNo"
          >
          </el-table-column>
        
          <el-table-column
            label="血糖"
            prop="sugar"
            align="center">
          </el-table-column>
          <el-table-column
            label="状态"
            align="center"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.ano == 0?'正常':'异常' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="测量时间"
            prop="createdTime"
            align="center">
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  data() {
    return {
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      deviceNo: "",
      loading:false,
      formInline:{
        user:null
      }
    };
  },
  methods: {
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    back(){
      bus.$emit('close_current_tags');
    },
    onSubmit(){
      this.pageNum = 1;
      this.getTableData();
    },

    // 生成随机测量数据
    generateMockData(deviceNo) {
      // dataCount deviceNo最后一位
      const dataCount = deviceNo.substr(deviceNo.length - 1);
      // const dataCount = Math.floor(Math.random() * 11) + 10; // 10-20条数据
      const mockData = [];
      
      for (let i = 0; i < dataCount; i++) {
        // 随机生成血糖值 (正常范围3.9-6.1mmol/L，异常值可能低于3.9或高于6.1)
        let sugar;
        const isAbnormal = Math.random() > 0.8; // 20%概率异常
        
        if (isAbnormal) {
          // 异常值：要么低于3.9，要么高于6.1
          sugar = Math.random() > 0.5 
            ? (Math.random() * 1.9 + 2).toFixed(1)  // 2.0-3.9
            : (Math.random() * 3 + 6.1).toFixed(1); // 6.1-9.1
        } else {
          // 正常值：3.9-6.1
          sugar = (Math.random() * 2.2 + 3.9).toFixed(1);
        }
        
        // 生成随机时间（过去7天内）
        const date = new Date();
        const randomDays = Math.floor(Math.random() * 30);
        date.setDate(date.getDate() - randomDays);
        
        // 随机小时和分钟
        date.setHours(Math.floor(Math.random() * 24));
        date.setMinutes(Math.floor(Math.random() * 60));
        date.setSeconds(Math.floor(Math.random() * 60));
        
        const formattedTime = date.toISOString().slice(0, 19).replace('T', ' ');
        
        
        mockData.push({
          id: i + 1,
          deviceNo: deviceNo,
          sugar: parseFloat(sugar),
          ano: isAbnormal ? 1 : 0, // 0-正常，1-异常
          createdTime: formattedTime
        });
      }
      
      // 按时间倒序排列
      return mockData.sort((a, b) => new Date(b.createdTime) - new Date(a.createdTime));
    },
    //获取分页的紧急按钮数据  只获取pageSize条数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceNo: this.deviceNo,
        user: this.formInline.user,//角色
        ano: this.formInline.ano,//角色
      };
      console.log(param);
      this.loading = true;
      this.list = this.generateMockData(this.deviceNo);
      this.totalDataNumber = this.list.length;
      this.loading = false;


    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getTableData();
    },
  },
  mounted() {
    this.deviceNo = this.$route.query.deviceNo;
    this.getTableData();
  },
};
</script>
<style lang="scss" scoped>
.buttonlist {
  .buttonlist-m {
    padding: 10px 0 0 5px;
  }
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
</style>